var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 114,
    viewBox: "0 0 101 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.42 38.95V38.93C95.81 34.44 93.62 30.16 90.91 26.22C86.9 20.44 81.88 15.57 75.99 11.72C70.98 8.61 65.59 6.09 59.98 4.25C54.69 2.57 49.21 1.46 43.7 0.969995C41.57 0.739995 39.4 0.619995 37.27 0.619995H0L1.17 1.7C4.24 4.53 6 8.54999 6 12.73V101.14C6 105.32 4.24 109.34 1.17 112.17L0 113.25H37.32C39.3 113.25 41.29 113.15 43.24 112.96C54.79 112.04 66.11 108.32 75.96 102.18C85.86 95.75 93.48 86.07 97.42 74.93C99.42 69.13 100.42 63.04 100.42 56.94C100.42 50.84 99.42 44.75 97.42 38.95ZM86.07 71.27C84.96 74.95 83.48 78.55 81.66 81.94C78.85 87.17 75.32 91.95 71.16 96.16C67.32 99.92 62.93 103.06 58.13 105.48C51.66 108.57 44.46 110.2 37.27 110.18H18.29V3.67H37.28C44.42 3.68 51.67 5.27999 58.13 8.35999C62.94 10.79 67.33 13.92 71.17 17.68C75.33 21.9 78.86 26.68 81.67 31.91C88.21 43.72 89.86 57.9 86.19 70.89L86.07 71.27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkWhite);
export default __webpack_public_path__ + "static/media/Mark_White.ab6b2ba5599d8f5494e9af70f260c89d.svg";
export { ForwardRef as ReactComponent };